<template>
  <section
    class="cell padding-bottom-1"
  >
    <article class="pega-information-container">
      <div class="pega-information-content">
        <ul class="pega-information-content-ul">
          <li
            v-for="(information, index) in informations"
            :key="index"
            :data-test="`information-modal-title-li-${index}`"
            class="pega-information-content-li"
          >
            <a
              :data-test="`information-modal-title-${index}`"
              @click="openInformationModal(index)"
            >{{ information.title }}</a>{{ information.createDate | formatDate }}
          </li>
        </ul>
      </div>
    </article>
    <!-- お知らせモーダル -->
    <div
      id="information-modal"
      class="reveal boss-modal-container pega-modal-position pega-information-modal-layout"
      data-reveal
    >
      <h1
        class="boss-page-title boss-page-title-layout-title font-bold padding-right-2"
        data-test="modal-title"
      >
        {{ informations[openInformationModalIndex].title }}
      </h1>
      <div
        class="pega-information-modal-body"
        data-test="modal-body"
        v-html="renderBody"
      />
      <div
        v-if="informations[openInformationModalIndex].files.length"
        class="margin-top-1"
        data-test="information-files"
      >
        <a
          v-for="(file, index) in informations[openInformationModalIndex].files"
          :key="index"
          class="display-block"
          :data-test="`modal-file-${index}`"
          @click="download(file.id, file.name)"
        >
          {{ file.name }}
        </a>
      </div>
      <button
        class="close-button boss-close-button boss-icon-cross"
        data-test="modal-close"
        data-close
        aria-label="Close modal"
        type="button"
        @click="closeReveal()"
      />
    </div>
    <!-- お知らせモーダル -->
  </section>
</template>

<script>
import util from '@/lib/util'
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import dayjs from 'dayjs'
import { downloadFile } from '@/lib/download'

export default {
  filters: {
    formatDate (val) {
      return dayjs(val).format('(YYYY/MM/DD)')
    }
  },
  props: {
    informations: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      openInformationModalIndex: 0
    }
  },
  computed: {
    renderBody () {
      return util.replaceAddressAndUrlLink(this.informations[this.openInformationModalIndex].body)
    }
  },
  methods: {
    openInformationModal (index) {
      if (!this.modal) {
        this.modal = new Foundation.Reveal(jQuery('#information-modal'))
      }
      this.$set(this, 'openInformationModalIndex', index)
      this.modal.open()
    },
    closeReveal () {
      this.modal.close()
    },
    download (fileId, fileName) {
      downloadFile(`/company/informations/${this.informations[this.openInformationModalIndex].id}/files/${fileId}/download`, fileName)
    }
  }
}
</script>
